import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="450"
      height="190"
      version="1.1"
      viewBox="0 0 119.063 50.271"
    >
      <g>
        <circle
          cx="59.752"
          cy="57.412"
          r="56.529"
          fill="red"
          fillOpacity="0"
          fillRule="evenodd"
          stroke="#000"
          strokeDasharray="none"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="1.323"
        ></circle>
      </g>
    </svg>
  );
}

export default Icon;
